<template>
	<div :class="tabIndex == 0 ? 'bg-w' : 'bg-F3F3F3'">
		<!-- <headers bg="#000" color="#fff"></headers> -->
		<headers></headers>
		<div class="tc-container py-5 body-height" >
			<div class="d-flex flex-wrap align-items-center" v-if="data_completed">
				<div class="d-flex align-items-center clickAct pe-4" v-for="(item,index) in list"
				:class="index==tabIndex? 'cl-theme ftw600':'cl-info'" @click="selectIndex(index) ">
					<div class="iconfont  ftr-1-5 mr5" :class="item.icon" ></div>
					{{item.name}}
				</div>
			</div>
			<div :class="data_completed? 'pt-4':''">
				<div v-if="tabIndex==0">
					<!-- <a-spin :spinning="loading"> 
					</a-spin> -->
					<teacher-center></teacher-center>
				</div>
				<div v-if="tabIndex==1">
					<teaching-archives :data_completed_info="data_completed_info" :defaultActiveKey="data_completed?'1':'9'"
					@changeIndex="changeTabIndex" @update="getTeacherInfo()" ></teaching-archives>
				</div>
				<div v-if="tabIndex==2">
					<my-class></my-class>
				</div>
				<div v-if="tabIndex==3">
					<my-students></my-students>
				</div>
				<div v-if="tabIndex==4">
					<class-manage @ok="okUpdate"></class-manage>
				</div>
				<div  v-if="tabIndex==5">
					<schedule @ok="okUpdate"></schedule>
				</div>
				<div  v-if="tabIndex==6">
					<statistics></statistics>
				</div>
				<div  v-if="tabIndex==7">
					<wallet></wallet>
				</div>
				<div  v-if="tabIndex==8">
					<teacherSet @ok="okUpdate"></teacherSet>
				</div>
			</div>
		</div>
		<footers></footers>
	</div>
</template>

<script>
	import teacherDetails from '../../components/teacher/teacherDetails.vue'
	import myClass from './components/myClass.vue'
	import myStudents from './components/myStudents.vue'
	import classManage from './components/classManage.vue'
	import schedule from './components/schedule.vue'
	import statistics from './components/statistics.vue'
	import wallet from './components/wallet.vue'
	import teacherSet from './components/teacherSet.vue'
	import teacherCenter from './components/teacherCenter.vue'
	import teachingArchives from './components/teachingArchives.vue'
	
	export default{
		components:{
			teacherDetails,
			myClass,
			myStudents,
			classManage,
			schedule,
			statistics,
			wallet,
			teacherSet,
			teacherCenter,
			teachingArchives
		},
		data(){
			return{
				tabIndex:0,
				form:{},
				list:[
					{
						name:this.$t('teacherIndex.teacherCenter'),
						icon:'icon-xueshengzongshu'
					},
					{
						name:this.$t('becomeTeacher.teachingArchives'),
						icon:'icon-xueshengzongshu'
					},
					{
						name:this.$t('teacherIndex.myClass'),
						icon:'icon-chuangjiangongkaike'
					},
					{
						name:this.$t('teacherIndex.myStudents'),
						icon:'icon-gongzuofankui'
					},
					{
						name:this.$t('teacherIndex.classManagement'),
						icon:'icon-zuizhongbaogao_yingyangyuansu'
					},
					{
						name:this.$t('teacherIndex.schedule'),
						icon:'icon-tongji'
					},
					{
						name:this.$t('teacherIndex.statistics'),
						icon:'icon-shuju'
					},
					{
						name:this.$t('teacherIndex.wallet'),
						icon:'icon-qianbao'
					},
					{
						name:this.$t('teacherIndex.settings'),
						icon:'icon-shezhi'
					}
				],
				loading:false,
				
				data_completed:localStorage.getItem('data_completed'),//是否达成开始教学条件，data_completed_info中所有字段都为true时，可以开始教学
				data_completed_info:{
					is_personal_profile:true,//个人资料
					is_pay:true,//收款方式
					is_video_tool:true,//视讯工具
					is_schedule:true,//日程
					is_class_manage:true,//课堂管理
					is_teaching_portfolio:true,//教学档案
					is_personal_photo:true,//个人照片
					is_work_experience:true,//工作经验
					is_self_introduction:true,//个人介绍
					is_introduction_film:true,//简介影片
					is_teaching_achievements:true,//教学成果
				}
			}
		},
		async created(){
			await this.getTeacherInfo()
			if(this.$route.query.tabIndex){
				this.tabIndex = Number(this.$route.query.tabIndex)
			}
		},
		methods:{
			okUpdate(){
				if(!this.data_completed){
					this.tabIndex = 1
					this.getTeacherInfo()
				}
			},
			async getTeacherInfo(){
				if(this.loading) return
				this.loading = true
				await this.$http.api('teacher/teacher/info').then(res=>{
					this.loading = false
					this.form = res.info
					this.updateTeacherInfo(res.info)
					this.getSchedule()
					this.getIsClassManage()
					this.data_completed_info.is_personal_profile = this.handleVerification(['nationality','address','address_image','certificate_type','certificate_no','certificate_no_image'])
					this.data_completed_info.is_pay = this.handleVerification(['withdraw_bank_name','withdraw_bank_number','withdraw_zhuanshukuai','withdraw_paypal'])
					this.data_completed_info.is_video_tool = this.handleVerification(['contact_zoom_url','contact_zoom_pmi','contact_zoom_password','contact_voov_url','contact_voov_pmi','contact_voov_password'])
					
					this.data_completed_info.is_teaching_portfolio = this.handleVerification(['teacher_language','professor_level_id','course_classify_id','special_educational_experience_id','education_background_id']) 
					this.data_completed_info.is_personal_photo = this.handleVerification(['photo_image'])
					this.data_completed_info.is_work_experience = this.handleVerification(['work_experience'])
					this.data_completed_info.is_self_introduction = this.handleVerification(['synopsis','self_introduction_content'])
					this.data_completed_info.is_introduction_film = this.handleVerification(['video_files'])
					this.data_completed_info.is_teaching_achievements = this.handleVerification(['introduce_images'])
					setTimeout(()=>{
						if(this.countFalseValues(this.data_completed_info)==0){
							this.data_completed = true
							this.$forceUpdate()
						}else{
							this.data_completed = false
							this.tabIndex = 1
							
						}
						localStorage.setItem('data_completed',this.data_completed)
					},500)
					
				})
			},
			selectIndex(index){
				this.tabIndex=index
				if(this.tabIndex==1){
					this.getTeacherInfo()
				}
			},
			countFalseValues(obj) {
			    let falseCount = 0; // 初始化计数器
			
			    // 遍历对象的每个属性
			    for (let key in obj) {
			        if (obj.hasOwnProperty(key)) { // 确保属性是对象自身的属性
			            if (obj[key] === false) { // 检查值是否为 false
			                falseCount++; // 如果是 false，计数器加一
			            }
			        }
			    }
			
			    return falseCount; // 返回 false 的数量
			},
			// 验证对应的老师数据是否都已填写
			handleVerification(arr){
				let boo = true
				arr.forEach((item=>{
					if(this.form[item]==null||this.form[item]==undefined||this.form[item]==''){
						boo = false
					}
				}))
				return boo
			},
			getSchedule(){
				let boo = true
				this.$http.api('teacher/teacher/timeListNew').then(res => {
					if (res.teacherTime&&res.teacherTime.length!=0) {
						boo = true
					}else{
						boo = false
					}
					this.data_completed_info.is_schedule = boo
					
				})
			},
			getIsClassManage(){
				this.$http.api('course/classifyList',{
					includeCourse:1,
					teacherCourse:this.form.id
				}).then(res=>{
					let boo = true
					if (res.list&&res.list.length!=0) {
						boo = true
					}else{
						boo = false
					}
					this.data_completed_info.is_class_manage = boo
				})
				
			},
			changeTabIndex(e){
				this.tabIndex = e
			}
		}
	}
</script>

<style>
	@media (max-width:575.98px) {
		.tc-container {
			margin: auto;
			width: 100%;
			padding-left: 1.5rem !important;
			padding-right: 1.5rem !important;
		}
		
	}
	@media (min-width: 576px) {
		.tc-container {
			margin: auto;
			width: 580px;
		}
	
	}
	
	@media (min-width: 768px) {
		.tc-container {
			margin: auto;
			width: 700px;
		}
	}
	@media (min-width: 992px) {
		.tc-container {
			margin: auto;
			width: 900px;
		}
	}
	@media (min-width: 1200px) {
		.tc-container {
			margin: auto;
			width: 1100px;
		}
	}
	
	@media (min-width: 1400px) {
		.tc-container {
			margin: auto;
			width: 1300px;
		}
	}
</style>